<template>
  <div>
    <el-alert
      title="Please close window once printing complete"
      type="info"
      description="Please close window once printing complete. If the print prompt does not automatically show after a few seconds, use your browser's print functionailty manually"
      :closable="false"
      show-icon>
    </el-alert>
    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>
    <br />
    <pea-summary ref="peaSummary" :printing="true" v-on:fetchComplete="summaryFetchComplete" :peaId="mainPeaId" :disabled="true" v-on:updateYears="updateYears"></pea-summary>
    <br />
    <pea-status-history ref="peaStatusHistory" v-on:fetchComplete="historyFetchComplete" :peaId="mainPeaId"></pea-status-history>
    <br />
    <pea-financial-assets ref="peaFinancialAssets" v-on:fetchComplete="assetsFetchComplete" :peaId="mainPeaId" :disabled="true" :startingYear="startingYear"></pea-financial-assets>
    <br />
    <pea-cri ref="peaCRI" :peaId="mainPeaId" v-on:fetchComplete="criFetchComplete" :disabled="true" :disableButton="true"></pea-cri>
    <br />
    <pea-documents ref="peaDocuments" v-on:fetchComplete="documentsFetchComplete" :peaId="mainPeaId" :disabled="true"></pea-documents>
    <br />
    <pea-financial-summary ref="peaFinancialSummary" v-on:fetchComplete="financeFetchComplete" :peaId="mainPeaId" :disabled="true" :canEditCostToDate="false"></pea-financial-summary>
    <br />
    <pea-check ref="peaCheck" :peaId="mainPeaId" v-on:fetchComplete="checkFetchComplete" :disabled="true"></pea-check>
    <br />
    <pea-authorization ref="peaAuthorization" v-on:fetchComplete="authorizationFetchComplete" :peaId="mainPeaId" :canEditPea="false" :isApprover="false"></pea-authorization>
    <br />
    <pea-comment ref="peaComment" :disabled="true" v-on:fetchComplete="commentFetchComplete" :peaId="mainPeaId" ></pea-comment>
  </div>
</template>

<script>
export default {
  name: 'peaPrint',
  props: [
    'peaId'
  ],
  data () {
    return {
      isLoading: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      peaSummaryValidState: false,
      peaFinancialSummaryValidState: false,
      peaFinancialAssetValidState: false,
      peaDocumentValidState: false,
      mainPeaId: this.peaId,
      disableEditing: true,
      canEditPEA: false,
      canEditPartialPEA: false,
      isApprover: false,
      canApprovePEA: false,
      canWithdrawPEA: false,
      disableFinancialSummary: true,
      disableCRI: true,
      disableDocuments: true,
      canEditCostToDate: false,
      startingYear: new Date().getFullYear(),
      peaDeleted: false,
      summaryFetchCompleted: false,
      historyFetchCompleted: false,
      assetsFetchCompleted: false,
      criFetchCompleted: false,
      documentsFetchCompleted: false,
      financeFetchCompleted: false,
      checkFetchCompleted: false,
      authorizationFetchCompleted: false,
      commentFetchCompleted: false
    }
  },
  created: function () {
  },
  methods: {
    updateYears () {
      this.startingYear = this.$refs.peaSummary.peaCore.projectStartDate.getFullYear()
    },
    summaryFetchComplete () {
      this.summaryFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    historyFetchComplete () {
      this.historyFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    assetsFetchComplete () {
      this.assetsFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    criFetchComplete () {
      this.criFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    documentsFetchComplete () {
      this.documentsFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    financeFetchComplete () {
      this.financeFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    checkFetchComplete () {
      this.checkFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    authorizationFetchComplete () {
      this.authorizationFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    commentFetchComplete () {
      this.commentFetchCompleted = true
      this.checkIfAllFetchDone()
    },
    checkIfAllFetchDone () {
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 15000)
      if (this.summaryFetchCompleted &&
        this.historyFetchCompleted &&
        this.assetsFetchCompleted &&
        this.criFetchCompleted &&
        this.documentsFetchCompleted &&
        this.financeFetchCompleted &&
        this.checkFetchCompleted &&
        this.authorizationFetchCompleted &&
        this.commentFetchCompleted) {
        loading.close()
        setTimeout(function () {
          if (this.alertType === '') {
            window.print()
          }
        }, 1000)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
